/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AuditorInputs */

const en_auditor = /** @type {(inputs: AuditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditor`)
};

const nl_auditor = /** @type {(inputs: AuditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditor`)
};

/**
* | output |
* | --- |
* | "Auditor" |
*
* @param {AuditorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const auditor = /** @type {((inputs?: AuditorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AuditorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_auditor(inputs)
	return en_auditor(inputs)
});